const AddOn = () => {
  return (
    <div className="min-h-6 w-fit rounded-3xl bg-aqua px-3 py-1 text-sm font-medium leading-5">
      {/* TODO: i18n Add On */}
      <span>Add On</span>
    </div>
  );
};

export default AddOn;
